<template>
  <!-- 九宫格抽奖 -->
  <div class="container">
    <div class="box">
      <div
        class="item"
        :class="{
          grayscaled:
            lotteryPending &&
            !i.isBtn &&
            i.index !== Math.floor(currentHighlightIndex % 8)
        }"
        :style="i.isBtn ? fireBtnBgStyle : rewardBgStyle"
        v-for="i in blocks"
        :key="i.key"
        @click="i.tapHandler ? i.tapHandler() : () => {}"
      >
        <div class="awardIcon"><Award :awardData="i" /></div>
        <div>{{ i.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Award from './LotteryAward';
import TWEEN from '@tweenjs/tween.js';

const LOOP_SPEED = 100; // 转动速度ms

export default {
  components: {
    Award
  },
  data() {
    return {
      currentHighlightIndex: 0,
      lotteryPending: false
    };
  },
  props: {
    lotteryAwards: Array,
    lotterySetting: Object,
    lotteryResult: Array,
    lotteryTicketCount: Number
  },
  watch: {
    lotteryResult: function(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (newVal.length) {
          this.rollingToTarget(newVal[0].rewardPoolId);
          this.reportDraw(1);
        } else {
          this.reset();
          this.$emit('lotteryFinish');
          this.reportDraw(0);
        }
      }
      if (oldVal && !newVal) {
        this.reset();
      }
    }
  },
  computed: {
    rewardBgStyle() {
      return {
        backgroundImage: `url("${this.lotterySetting.gridBackgroundImage}")`
      };
    },
    fireBtnBgStyle() {
      return {
        backgroundImage: `url("${this.lotterySetting.buttonImage}")`
      };
    },
    fireBtnObj() {
      return {
        isBtn: true,
        tapHandler: this.handleTapStart
      };
    },
    awardsWithIndex() {
      return this.lotteryAwards.map((item, i) => ({ ...item, index: i }));
    },
    blocks() {
      return [
        { key: 0, ...this.awardsWithIndex[0] },
        { key: 1, ...this.awardsWithIndex[1] },
        { key: 2, ...this.awardsWithIndex[2] },
        { key: 3, ...this.awardsWithIndex[7] },
        { key: 4, ...this.fireBtnObj },
        { key: 5, ...this.awardsWithIndex[3] },
        { key: 6, ...this.awardsWithIndex[6] },
        { key: 7, ...this.awardsWithIndex[5] },
        { key: 8, ...this.awardsWithIndex[4] }
      ];
    }
  },
  methods: {
    checkTicket() {
      const hasTicket = this.lotteryTicketCount > 0;
      if (!hasTicket) {
        this.$emit('noTicket');
      }
      return hasTicket;
    },
    handleTapStart() {
      if (this.lotteryPending) {
        return;
      }
      if (!this.checkTicket()) {
        this.reportDraw(0);
        return;
      }
      this.lotteryPending = true;
      setTimeout(() => {
        this.$emit('fire');
      }, 1000);
      this.currentHighlightIndex = 0;
      const maxIndex = this.lotteryAwards.length;
      const _this = this;
      this.loopTween = new TWEEN.Tween(this.$data)
        .to({ currentHighlightIndex: maxIndex }, LOOP_SPEED * 7)
        .repeat(Infinity)
        .onComplete(() => {
          _this.currentHighlightIndex = 0;
        })
        .start();

      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }

      animate();
    },
    rollingToTarget(resultId) {
      this.loopTween.repeat(0); // 先将无限滚动停下
      const resultReward = this.awardsWithIndex.find(
        i => i.rewardPoolId === resultId
      );
      const resultIndex = resultReward.index;
      const leftCount = resultIndex + 8;
      const leftTime = leftCount * LOOP_SPEED * 1.5;
      const endTween = new TWEEN.Tween(this.$data)
        .to({ currentHighlightIndex: leftCount }, leftTime)
        .easing(TWEEN.Easing.Sinusoidal.Out)
        .onComplete(() => {
          setTimeout(() => {
            this.$emit('lotteryFinish');
          }, 300);
        });
      this.loopTween.chain(endTween); // 在无限滚动之后接上缓动停止动画
    },
    reset() {
      this.lotteryPending = false;
      this.currentHighlightIndex = 0;
      this.loopTween && this.loopTween.stop();
    },
    reportDraw(is_success = 1) {
      this.$emit('reportDraw', {
        is_success
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.box {
  width: 540px;
  height: 540px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .item {
    width: 170px;
    height: 170px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    &.grayscaled {
      opacity: 0.8;
    }

    .awardIcon {
      width: 122px;
      height: 122px;
      font-size: 28px;
    }
  }
}
</style>
